module.exports = __webpack_public_path__ + "static/media/Cash_reversal.e04943a7.svg";